/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingconnectdescription2Inputs */

const en_crosspostingconnectdescription2 = /** @type {(inputs: Crosspostingconnectdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link this place's Facebook and Instagram accounts.`)
};

const de_crosspostingconnectdescription2 = /** @type {(inputs: Crosspostingconnectdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbinde die Facebook- und Instagram-Konten dieses Ortes.`)
};

/**
* | output |
* | --- |
* | "Link this place's Facebook and Instagram accounts." |
*
* @param {Crosspostingconnectdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingconnectdescription2 = /** @type {((inputs?: Crosspostingconnectdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingconnectdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingconnectdescription2(inputs)
	return de_crosspostingconnectdescription2(inputs)
});
export { crosspostingconnectdescription2 as "crosspostingConnectDescription" }